module.exports = __webpack_public_path__ + "static/404-Error-Page-04-5be35c9c4ebae0754ad37028353962b8.jpg";